import Joi from 'joi';
import { rutValidation } from '../../../../helpers/RutValidator';
import { ocValidation } from '../../../../helpers/OcValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  orderId: ocValidation.orderId().validateOc(),
});
